import React from 'react';
import axios from 'axios';

import OfferTypeTabs from './components/tabs/index';
import Loader from './components/hotels_list/loader';
import HotelNameSearcher from './components/HotelNameSearcher';

import {
  link2OfferDescriptionWithHotel,
  fetchHotelsList
} from '../../services/services';
import { T } from '../../../../common/locale/translate';
import { historyService } from '../../services/history';

export default class HotelsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: null,
      loader: false,
      sort_by: 'name',
      sort_asc: true,
      offer_type: props.offer_type || 'S',
      region_id: props.region_id,
      region_name: props.region_name,
      region_slug: props.region_slug,
      hotel_name: props.hotel_name,
      hotels: []
    };
  }

  componentDidMount = () => {
    this.setState(
      {
        loader: true
      },
      () => {
        fetchHotelsList(
          this.state.offer_type,
          this.state.region_id,
          this.state.hotel_name
        ).then(
          response => {
            if (response.status == 204) {
              this.setState(
                {
                  loader: false
                },
                () => this.redirectToRegionsList()
              );
            } else {
              this.setState(
                {
                  loader: false,
                  hotels: response.data.hotels
                },
                () => this.forceUpdate()
              );
            }
          },
          error => {
            if (axios.isCancel(error)) {
              console.log('GetHotelsList - Request canceled');
            } else {
              this.setState({
                loader: false
              });
            }
          }
        );
      }
    );
  };

  render = () => {
    const { params } = this.props;
    const breadcrumbs = this.state.breadcrumbs || this.props.breadcrumbs;
    let hotelsHeader = this.renderHotelsHeader();
    let goBackHeader = this.renderGoBackHeader();
    let hotelsElement = this.renderHotels();
    let loaderElement = this.renderLoader();

    return (
      <div className="hotels-wrapper">
        <section className="offer-type-tabs">
          <OfferTypeTabs
            params={params}
            breadcrumbs={breadcrumbs}
            handleTabChange={this.handleOfferTabClick}
          />
        </section>
        {this.props.region_type == 'search-results' && [
          <div className="hotel-name-searcher">{this.renderSearcher()}</div>,
          <div className="hotel-name-message">
            {T('hotel_name_search_message')}&nbsp;
            <span className="hotel-name-search-results">
              {this.state.hotel_name}:
            </span>
          </div>
        ]}
        <div className="hotels-header">{hotelsHeader}</div>
        <div className="go-back-header">{goBackHeader}</div>
        <div className="hotels-list">{hotelsElement}</div>
        <div className="hotels-loader">{loaderElement}</div>
      </div>
    );
  };

  getLocationHeader = () => {
    switch (this.props.region_type) {
      case 'search-results':
        return 'country-region-city';
      case 'country':
        return 'region-city';
      case 'region':
        return 'city';
      default:
        return 'location';
    }
  };

  getLocation = hotel => {
    switch (this.props.region_type) {
      case 'search-results':
        return this.renderCountriesHotelListLink(hotel);
      case 'country':
        return this.renderRegionsHotelListLink(hotel);
      case 'region':
        return hotel.city;
      default:
        return '-';
    }
  };

  renderSearcher = () => (
    <HotelNameSearcher
      offer_type={this.state.offer_type}
      initial_value={this.state.hotel_name}
    />
  );

  renderCountriesHotelListLink = hotel => [
    hotel.country && [
      <a
        className="hotels-list-link"
        href={`/hotele/${hotel.countryId}?offer_type=${this.state.offer_type}`}
      >
        {hotel.country}
      </a>,
      <span>,&nbsp;</span>
    ],
    hotel.region && [
      <a
        className="hotels-list-link"
        href={`/hotele/${hotel.regionId}?offer_type=${this.state.offer_type}`}
      >
        {hotel.region}
      </a>,
      <span>,&nbsp;</span>
    ],
    <span>{hotel.city}</span>
  ];

  renderRegionsHotelListLink = hotel => [
    <a
      className="hotels-list-link"
      href={`/hotele/${hotel.regionId}?offer_type=${this.state.offer_type}`}
    >
      {hotel.region}
    </a>,
    <span>,&nbsp;</span>,
    <span>{hotel.city}</span>
  ];

  renderHotelsHeader = () => (
    <div>
      {['name', `${this.getLocationHeader()}`, 'rating', 'opinions'].map(
        headerCategory => (
          <div
            className={`hotel-${headerCategory}-header`}
            onClick={() => this.handleSortHeaderClick(headerCategory)}
          >
            <span>{T(`hotel-${headerCategory}`)}</span>
            {this.state.sort_by == headerCategory && (
              <div className="sort-wrapper">
                <i
                  className={`fa fa-caret-${
                    this.state.sort_asc ? 'down' : 'up'
                  }`}
                />
              </div>
            )}
          </div>
        )
      )}
    </div>
  );

  renderGoBackHeader = () => (
    <div>
      <a href="/hotele">
        <i className="fa fa-chevron-left" />
        <span>{T('go_back_to_hotel_list')}</span>
      </a>
      {this.state.region_name && (
        <div className="region-name">{this.state.region_name}</div>
      )}
    </div>
  );

  getSortFunc = () => {
    let func = null;
    switch (this.state.sort_by) {
      case 'rating':
      case 'opinions':
        func = (a, b) =>
          parseFloat(a[this.state.sort_by]) - parseFloat(b[this.state.sort_by]);
        break;
      case 'country-region-city':
        func = (a, b) =>
          a.country != b.country
            ? (a.country || '').localeCompare(b.country || '')
            : a.region != b.region
              ? (a.region || '').localeCompare(b.region || '')
              : (a.city || '').localeCompare(b.city || '');
        break;
      case 'region-city':
        func = (a, b) =>
          a.region != b.region
            ? (a.region || '').localeCompare(b.region || '')
            : (a.city || '').localeCompare(b.city || '');
        break;
      case 'name':
      case 'city':
      default:
        func = (a, b) =>
          (a[this.state.sort_by] || '').localeCompare(
            b[this.state.sort_by] || ''
          );
    }
    return (a, b) => func(a, b) * (this.state.sort_asc ? 1 : -1);
  };

  renderHotels = () => {
    if (this.state.loader || this.state.hotels.length > 0) {
      const sortFunc = this.getSortFunc();

      return this.state.hotels.sort(sortFunc).map((hotel, index) => (
        <div className="hotel-wrapper" key={index}>
          <a className="hotel-name" href={this.hotelHref(hotel)}>
            <span>{hotel.name}</span>
          </a>
          <div className={`hotel-${this.getLocationHeader()}`}>
            <span>{this.getLocation(hotel)}</span>
          </div>
          <div className="hotel-rating">
            <span
              className={`stars stars-${hotel.rating
                .toString()
                .replace('.', '')}`}
            />
          </div>
        </div>
      ));
    } else {
      return (
        <div className="no-hotels-found-wrapper">
          <span>{T('no_hotels_found')}</span>
        </div>
      );
    }
  };

  hotelHref = hotel =>
    link2OfferDescriptionWithHotel(this.offerLinkParams(hotel));

  handleSortHeaderClick = header_name => {
    if (this.state.sort_by == header_name) {
      this.setState(prevState => ({
        ...prevState,
        sort_asc: !prevState.sort_asc
      }));
    } else {
      this.setState({ sort_by: header_name, sort_asc: true });
    }
  };

  handleOfferTabClick = offer_type => {
    let params = historyService.params();
    params =
      typeof params['offer_type'] == 'undefined' ? this.props.params : params;
    if (offer_type !== params['offer_type']) {
      params['offer_type'] = offer_type;
      const url = offer_type
        ? `/hotele/${this.state.region_slug ||
            'szukaj'}?${historyService.parseObject2Params(params)}`
        : null;
      window.location.href = url;
    }
  };

  redirectToRegionsList = () => {
    let params = historyService.params();
    const url = `/hotele?not_found=true${
      typeof params['hotel_name'] != 'undefined'
        ? `&hotel_name=${this.state.hotel_name}`
        : ''
    }`;
    window.location.href = url;
  };

  offerLinkParams = hotel => ({
    id: hotel.id.split('|')[0],
    operator_code: hotel.id.split('|')[1],
    parser: hotel.parserAlias,
    offer_type: this.state.offer_type
  });

  renderLoader = () => (
    <Loader active={this.state.loader} className="general-content-loader" />
  );
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/hotels_list.jsx